import { Injectable } from '@angular/core';

 
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';

//import { loadavg } from 'os';

@Injectable()
export class AuthService {
  isLoggedIn = false;

  // store the URL so we can redirect after logging in

  redirectUrl: string;

  isUserLoggedIn(): boolean {
    var token = localStorage["token"];
    return typeof(token) != "undefined";
  }

  login(token: string) {
    localStorage["token"] = token;
    this.isLoggedIn = true;
    return;
  }

  logout(): void {
    this.isLoggedIn = false;
    localStorage.removeItem("token");
  }

}


// WEBPACK FOOTER //
// C:/Users/tormo/Documents/InterNova/Kunder/Mattilsynet/plvmWEB/webapp/src/_services/auth.service.ts